import type { Sort } from '../types/QueryTypes';
function compareValues(a: unknown, b: unknown, direction: 'asc' | 'desc'): number {
  const mult = direction === 'asc' ? 1 : -1;
  if (a === null || a === undefined) return 1;
  if (b === null || b === undefined) return -1;
  if (typeof a === 'number' && typeof b === 'number') {
    return (a - b) * mult;
  }
  const strA = String(a).toLowerCase();
  const strB = String(b).toLowerCase();
  return strA.localeCompare(strB) * mult;
}
export function applySort(rows: Record<string, unknown>[], sorts: Sort[]): Record<string, unknown>[] {
  if (!sorts || sorts.length === 0) return rows;
  return [...rows].sort((a, b) => {
    for (const sort of sorts) {
      const aVal = a[sort.field];
      const bVal = b[sort.field];
      const cmp = compareValues(aVal, bVal, sort.direction);
      if (cmp !== 0) return cmp;
    }
    return 0;
  });
}